import { IAppPermissionsDomain, IAppPermissionsFragment } from 'graphql/types';
import { parseJSON } from 'common/utils/json';
import { TAppPermissionsObj, TPermissionValue } from 'user/types';

/**
 * Parses the `appPermissions` JSONString and unwraps the map nested under the
 * lowercased `domain` key. Returns an empty map when missing or malformed.
 */
export function parseAppPermissions(
    appPermissions: string | null | undefined,
    domain: IAppPermissionsDomain
): TPermissionValue {
    if (!appPermissions) return {};

    return parseJSON(appPermissions)?.[domain.toLowerCase()] ?? {};
}

export function getParsedAppPermissions(
    appPermissions?: IAppPermissionsFragment | null
): TAppPermissionsObj | undefined {
    if (!appPermissions) return undefined;

    return Object.entries(appPermissions).reduce(
        (acc, [key, objectPermissions]) => {
            if (key === '__typename' || !objectPermissions) return acc;

            return {
                ...acc,
                [key]: Object.entries(objectPermissions).reduce(
                    (permAcc, [permKey, permission]) => {
                        if (permKey === '__typename' || !permission)
                            return permAcc;

                        return {
                            ...permAcc,
                            [permKey]: JSON.parse(permission),
                        };
                    },
                    {}
                ),
            };
        },
        {} as TAppPermissionsObj
    );
}
